<template>
  <div>
    <v-card class="elevation-0">
      <v-card-text class="pt-0">
        <v-data-table
          :headers="comp_headers"
          :items="loading? [] : items"
          class="elevation-0"
          :search="tableSearch"
          ref="table"
          :loading='loading'
          mobile-breakpoint="1"
        >
          <template v-slot:top>
            <v-row v-if="selected.length > 1 && with_select" justify="center" align="center">
              <v-col cols='3' align='right'>
                <v-btn :color="selected[0].status_id == status_id_map['Payed'] ? 'primary' : 'success'" @click="updateManyExchanges()" rounded>
                  {{selected[0].status_id == status_id_map['Payed'] ? 'Confirmar' : 'Em conta'}}
                </v-btn>
              </v-col>
              <v-col cols='3'>
                <v-card class="blue-grey darken-1" style="border-radius:12px">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5" justify="center">
                      <v-icon x-large class="mr-5" color='white'>mdi-currency-usd</v-icon>
                      <span class="title white--text">{{ selected.reduce((acc,one) => acc + Number(one.value), 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            
            <v-row justify="center">
              <v-col cols='5'>
                <v-card style="border-radius:12px">
                  <v-card-text class="pa-2">
                    <v-row align="center" class="px-5" justify="center">
                      <v-icon x-large class="mr-5" color='blue-grey darken-3'>mdi-currency-usd</v-icon>
                      <span class="title">{{ total_value_sum.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols='5'>
                <v-card style="border-radius:12px">
                  <v-card-text class="pa-2">
                    <v-row align="center" class="px-5" justify="center">
                      <v-icon x-large class="mr-5" color='blue-grey darken-3'>mdi-credit-card-outline</v-icon>
                      <span class="title">{{ total_exchanges }} permutas</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.created_at="{item}">
            {{ $moment(item.created_at.substring(0,10)).format('L') }}
          </template>

          <template v-slot:item.ammount="{item}">
            {{ Number(item.ammount).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
          </template>

          <template v-slot:item.order_id="{item}">
            #{{ item.order_id || item.external_order_id }} 
          </template>

          <template v-slot:item.action="{item}">
            <v-btn small color="success" v-if="item.status=='open'" rounded  @click="concludeExchange(item)" :disabled="!can_operate"> <v-icon left>mdi-check</v-icon> receber</v-btn>
            <v-btn small color="error" v-if="item.status=='payed'" rounded  @click="backExchange(item)" :disabled="cannot_operate"> <v-icon left>mdi-arrow-left-bold</v-icon> reabrir</v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <exchange-dialog :exchange="exchange" :exchange_dialog="exchange_dialog" @close="closeDialog" @doneUpdate="handleDoneUpdate" @doneReturned="handleDoneReturned" @doneDelete="handleDoneDelete"></exchange-dialog>
  
    <dialog-loading v-if="saving" color='error' loadingText="Salvando"></dialog-loading>

    <dialog-loading v-if="dialog_error" color='error' loadingText="Não é permitido selecionar depósitos com status diferentes"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';
import status from "@/_backoffice/_financial/mixins/status.js"

export default {
  name: 'ExchangeTable',
  mixins: [ status ],
  props: {
    items: {
      type: Array
    },
    headers: {
      type: Array
    },
    title: {
      type: String
    },
    with_date_search: {
      type: Boolean,
      default: false
    },
    with_select: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    /** Texto vindo do FilterData (busca no `v-data-table`). */
    tableSearch: {
      type: String,
      default: ''
    },

    dialog_error: false,
    dialog_error_text: 'Não é permitido selecionar depósitos com status diferentes'
  },
  components: {
    ExchangeDialog: () => import('./ExchangeDialog'),
  },
  data() {
    return {
      headers_default: [
        { text: 'Data', value: 'created_at', align: 'center' },
        { text: 'Módulo', value: 'place_name', align: 'center' },
        { text: 'Cliente', value: 'client_name', align: 'center' },
        { text: 'Venda', value: 'order_id', align: 'center' },
        { text: 'Valor', value: 'ammount', align: 'center' },
        { text: 'Ação', value: 'action', align: 'center' },
      ],
      selected: [],
      exchange_dialog: false,
      exchange: {},
      initial_date_menu: false,
      end_date_menu: false,
      initial_date: null,
      end_date: null,
      select_status: null,
      checkbox_item: null,
      loading_one_exchange: false,
      saving: false,
    }
  },
  computed: {
    can_operate() {
      return this.isDirector()
    },
    cannot_operate(){
      return this.isCreditAnalyst();
    },
    comp_headers(){
      return this.headers || this.headers_default
    },
    total_value_sum() {
      if (this.$refs.table && this.tableSearch) {
        return this.$refs.table.internalCurrentItems.reduce((acc, one) => acc + Number(one.ammount), 0)
      }
      return this.items.reduce((acc, one) => acc + Number(one.ammount), 0)
    },
    total_exchanges() {
      if (this.$refs.table && this.tableSearch) {
        return this.$refs.table.internalCurrentItems.length
      }
      return this.items.length
    },
  },
  methods: {
    concludeExchange(item){
      this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        title: `Deseja concluir permuta?`,
        icon: 'question',
      }).then(r=>{
        if (r.isConfirmed) {
          this.saving = true
          this.loadingText = 'Concluindo'

          let obj = {
            id: item.id,
            status: 10,
          }
          Api.Exchange.update(obj).then(r=r.data).then(d=>{
            this.$emit('doneUpdate')
            this.saving = false
          })
          
        }
      })
    },
    backExchange(item){
      this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        title: `Deseja reabrir premuta?`,
        icon: 'question',
      }).then(r=>{
        if (r.isConfirmed) {
          this.saving = true
          this.loadingText = 'Concluindo'

          let obj = {
            id: item.id,
            status: 1,
          }
          Api.Exchange.update(obj).then(r=r.data).then(d=>{
            this.$emit('doneUpdate')
            this.saving = false
          })
          
        }
      })
    },
    updateManyExchanges(){
      let c = confirm('Atualizar depósitos selecionados?')
      if (c){
        this.$emit('toUpdateMany', this.selected)
      }
    },
    showExchange(item) {
      this.loading_one_exchange = true
      this.exchange_dialog = true
      this.exchange = null
      this.exchange = {...item}
      this.loading_one_exchange = false
    },

    closeDialog() {
      this.exchange_dialog = false
      this.exchange = null
    },


    checkForSameStatus() {
      let status_ids = this.selected.map(s => s.status_id)

      let unique_statuses = [...new Set(status_ids)]

      if (unique_statuses.length > 1){
        this.dialog_error = true

        setTimeout(() => {
          let status_1 = unique_statuses[0]
          let more_used_status = status_1
          let status_count = {}
          for (let index = 0; index < unique_statuses.length; index++) {
            status_count[index] = status_ids.filter(s=> s == unique_statuses[index]).length
            if (index > 0){
              more_used_status = (status_count[index] > status_count[index-1])? unique_statuses[index] : unique_statuses[index-1]
            }
          }

          this.selected = this.selected.filter(s=> s.status_id == more_used_status)

          this.dialog_error = false
        }, 3000);
      } else {

      }
    },
    handleDoneUpdate(){
      this.$emit('doneUpdate')
    },
    handleDoneReturned(){
      this.exchange_dialog = false
      this.$emit('doneReturned')
    },
    handleDoneDelete(){
      this.exchange_dialog = false
      this.$emit('doneDelete')
    },
  },
  watch: {
    selected(nv, ov) {
      if (nv.length > ov.length) {
        this.checkForSameStatus()
      }
    },
    loading(nv,ov) {
      if (nv){
        this.selected = []
      }
    }
  },
}
</script>
